module.exports = "/images/save-icon.svg";